import React, {useEffect, useState} from 'react';
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaAngleDoubleLeft, FaSearch} from "react-icons/fa";
import {useMapsLibrary} from "@vis.gl/react-google-maps";
import projectUtils from "../../../../utils/project-utils.js";

const GisGeocoding = ({ map, isOpen, toggleGeocoding }) => {
    const [search, setSearch] = useState("");

    const geocoding = useMapsLibrary('geocoding');

    useEffect(() => {
        if (!isOpen) setSearch("")
    }, [isOpen]);

    const onClick = () => {
        if (!search) return;

        const geocoder = new geocoding.Geocoder();
        geocoder.geocode({'address': search}, function (results, status) {
            if (status === "ZERO_RESULTS") {
                projectUtils.swalErrorMessage("", "Endereço não encontrado", "Ok")
            }

            if (status === 'OK') {
                map.setZoom(18);
                map.setCenter(results[0].geometry.location);
            }
        });
    }

    const handleKeyDown = ({key}) => {
        if (key === 'Enter') onClick();
    }

    const handleInput = ({target: {value}}) => setSearch(value);

    return (
        <Card className={"h-fit! w-78.75"} hidden={!isOpen}>
            <Card.Body>
                <span className="hide-details" title="Fechar" onClick={toggleGeocoding}>
                    <FaAngleDoubleLeft />
                </span>
                <h3 className="font-bold mt-1">Endereço</h3>

                <hr className={"text-[#bdbdbd]"}/>

                <div className="flex gap-1">
                    <InputForm
                        classNameWrapper={"w-2xs"}
                        inputClass={"!bg-white"}
                        value={search}
                        type={"search"}
                        onChange={handleInput}
                        onKeyDown={handleKeyDown}
                    />

                    <Button target={"primary"} onClick={onClick}>
                        <FaSearch />
                    </Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default GisGeocoding;